"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Upload = props => {
  const {
    name,
    label,
    required,
    addition
  } = props;
  if (!name) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, props, {
    required: required,
    label: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    }),
    fullWidth: true,
    name: name,
    type: "file",
    InputLabelProps: {
      shrink: true
    },
    variant: "outlined"
  })), addition ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, addition) : "");
};
var _default = exports.default = Upload;